import { connect } from 'react-redux';
import PlayerProfiles from '../../components/details/player_profiles';

const mapStateToProps = (state) => ({
  memberProfilesUrl: state.leaderboardV2.memberProfilesUrl,
});

export default connect(mapStateToProps)(PlayerProfiles);
